/* tslint:disable */
/* eslint-disable */
/**
 * David Master Api
 * db: david-master
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { SignDTOFromJSON, SignDTOToJSON, } from './SignDTO';
/**
 * Check if a given object implements the SignDTOListBaseResponse interface.
 */
export function instanceOfSignDTOListBaseResponse(value) {
    let isInstance = true;
    return isInstance;
}
export function SignDTOListBaseResponseFromJSON(json) {
    return SignDTOListBaseResponseFromJSONTyped(json, false);
}
export function SignDTOListBaseResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'items': !exists(json, 'items') ? undefined : (json['items'] === null ? null : json['items'].map(SignDTOFromJSON)),
        'count': !exists(json, 'count') ? undefined : json['count'],
    };
}
export function SignDTOListBaseResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'items': value.items === undefined ? undefined : (value.items === null ? null : value.items.map(SignDTOToJSON)),
        'count': value.count,
    };
}
